import React from 'react'
import { Link } from 'react-router-dom'
import Resx from '@/components/Resx'

export default (props) => {
  return (
    <div className='no-dashboard-item'>
      <Resx name='Common.NoDashboardWidgetMesage' />&nbsp;
      <Link to='/dashboard-settings'><Resx name='Common.GoToDashboardSettings' /></Link>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/dashboard/noWidgetsMessage.js